























































































































































































































import Vue from 'vue';
import router from '@/router';
import NavbarComp from '../modules/NavbarComp.vue';
import FooterComp from '../modules/FooterComp.vue';
import LoadingDialogComp from '../modules/LoadingDialogComp.vue';
import GeneralDialogComp from '../modules/GeneralDialogComp.vue';
import VueQriously from 'vue-qriously';
import { APIClient } from '@/libs/ApiClient';
import { ErrorUtils } from '@/libs/ErrorUtils';

Vue.use(VueQriously);

export default Vue.extend({
  name: 'Detail',
  props: ['txHash'],
  data() {
    return {
      valid: true,
      deleteConfirmDialog: false,
      tipDialog: false,
      galleryDialog: false,
      item: { owner: '', fromMultisig: '', txHash: '' },
      onwerNamespaces: [],
      multisigNamespaces: [],
      deleteKey: '',
      deleteKeyRules: [
        (v: string) => !!v ||　this.$t('common.validateDeleteKey').toString(),
      ],
      deleteLoadingMessage: this.$t('detail.deleting').toString(),
      isLoading: false,
      isShowGeneralDialog: false,
      generalDialogMessage: '',
      generalDialogEmit: 'reset',
      isShowToTopDialog: false,
      toTopDialogMessage: '',
      toTopDialogEmit: 'toTopReset',
    };
  },
  async created() {
    await this.getApostille();
  },
  methods: {
    async getApostille() {
      try {
        this.item = await APIClient.getApostilleByTxHash(this.txHash);
      } catch (err) {
        this.showToTopDialog(this.$t('common.apostilleNotFound').toString());
        return;
      }
      this.getOwnerNamespace(this.item.owner);
      if (this.isShowMultiSig(this.item)) {
        this.getMultisigNamespace(this.item.fromMultisig);
      }
    },
    showTipDialog() {
      this.tipDialog = true;
    },
    showGalleryDialog() {
      this.galleryDialog = true;
    },
    showDeleteDialog() {
      this.deleteConfirmDialog = true;
    },
    onClipCopy(e: any) {
      this.showDialog(this.$t('common.copied').toString());
    },
    onClipError(e: any) {
      this.showDialog(this.$t('common.cannotCopy').toString());
    },
    isShowImage(fileName: string) {
      if (!fileName) {
        return false;
      }
      console.log(fileName);
      let ext = fileName!.split('.').pop();
      if (ext === null) {
        return false;
      }
      ext = ext!.toLowerCase();
      if (ext === 'jpg' || ext === 'jpeg' || ext === 'png') {
        return true;
      }
      return false;
    },
    isShowOwnerNamespace(item: any) {
      if (this.onwerNamespaces && this.onwerNamespaces.length > 0) {
        return true;
      }
      return false;
    },
    isShowMultiSig(item: any) {
      if (item.fromMultisig !== undefined && item.fromMultisig !== '' && item.fromMultisig !== 'none' && item.fromMultisig !== item.owner) {
        return true;
      }
      return false;
    },
    isShowMultiSigNamespace(item: any) {
      if (this.multisigNamespaces && this.multisigNamespaces.length > 0) {
        return true;
      }
      return false;
    },
    getOwnerQRCodeJson() {
      const data = {
        v: 2,
        type: 2,
        data: {
          addr: this.item.owner,
          amount: 1 * 1_000_000,
          msg: 'Tip for your Apostille',
          name: 'Tip for apostille',
        },
      };

      return JSON.stringify(data);
    },
    async getOwnerNamespace(address: string) {
      this.onwerNamespaces = await APIClient.getNamespaces(address);
    },
    async getMultisigNamespace(address: string) {
      this.multisigNamespaces = await APIClient.getNamespaces(address);
    },
    async deleteApostille() {
      const form: any = this.$refs;
      if (!form.validate()) {
        return;
      }
      try {
        this.isLoading = true;
        const res = await APIClient.deleteApostille(this.item.txHash, this.deleteKey);
        this.isLoading = false;
        this.deleteConfirmDialog = false;
        this.showToTopDialog(this.$t('detail.deleted').toString());
      } catch (err) {
        this.isLoading = false;
        this.showDialog(ErrorUtils.getErrorMessageForDelete(err.response.data.code));
      }
    },
    showDialog(message: string) {
      this.generalDialogMessage = message;
      this.isShowGeneralDialog = true;
    },
    resetDialog() {
      this.isShowGeneralDialog = false;
      this.generalDialogMessage = '';
    },
    showToTopDialog(message: string) {
      this.isShowToTopDialog = true;
      this.toTopDialogMessage = message;
    },
    resetToTopDialog() {
      this.isShowToTopDialog = false;
      router.push('/');
    },
  },
  components: {
    NavbarComp,
    FooterComp,
    LoadingDialogComp,
    GeneralDialogComp,
  },
});
